import React from "react";
import "./styles/Navbar.css";
import { NavLink } from "react-router-dom";
import SearchIcon from "@material-ui/icons/Search";
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";
import PersonIcon from "@material-ui/icons/Person";

function Navbar() {
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light shadow">
        <div className="container d-flex justify-content-between align-items-center">
          <NavLink
            className="navbar-brand text-success logo h1 align-self-center"
            to="/"
          >
            MyShoP
          </NavLink>

          <button
            className="navbar-toggler border-0"
            type="button"
            data-toggle="collapse"
            data-target="#templatemo_main_nav"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className="align-self-center collapse navbar-collapse flex-fill  d-lg-flex justify-content-lg-between"
            id="templatemo_main_nav"
          >
            <div className="flex-fill">
              <ul className="nav navbar-nav d-flex justify-content-between mx-lg-auto">
                <li className="nav-item">
                  <NavLink className="nav-link" to="/">
                    Home
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/about">
                    About
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/shop">
                    Shop
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/contact">
                    Contact
                  </NavLink>
                </li>
              </ul>
            </div>
            <div className="navbar align-self-center d-flex">
              <div className="d-lg-none flex-sm-fill mt-3 mb-4 col-7 col-sm-auto pr-3">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    id="inputMobileSearch"
                    placeholder="Search ..."
                  />
                  <div className="input-group-text">
                    <i className="fa fa-fw fa-search"></i>
                  </div>
                </div>
              </div>
              <NavLink
                className="nav-icon d-none d-lg-inline"
                to="#"
                data-bs-toggle="modal"
                data-bs-target="#templatemo_search"
              >
                <SearchIcon />
              </NavLink>
              <NavLink
                className="nav-icon position-relative text-decoration-none"
                to="/"
              >
                <AddShoppingCartIcon className="text-dark mr-1" />
              </NavLink>
              <NavLink
                className="nav-icon position-relative text-decoration-none"
                to="#"
              >
                <PersonIcon className="text-dark mr-3" />
              </NavLink>
              <NavLink
                className="nav-icon position-relative text-decoration-none"
                to="/signup"
              >
                Sign up 
              </NavLink>
              <NavLink
                className="nav-icon position-relative text-decoration-none"
                to="/login"
              >
               Login
              </NavLink>
            </div>
          </div>
        </div>
      </nav>
      <div
      className="modal fade bg-white"
      id="templatemo_search"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="w-100 pt-1 mb-5 text-right">
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <form
          action=""
          method="get"
          className="modal-content modal-body border-0 p-0"
        >
          <div className="input-group mb-2">
            <input
              type="text"
              className="form-control"
              id="inputModalSearch"
              name="q"
              placeholder="Search ..."
            />
            <button
              type="submit"
              className="input-group-text bg-success text-light"
            >
              

              <SearchIcon className="text-white" />
            </button>
          </div>
        </form>
      </div>
    </div>

    </>
  );
}

export default Navbar;
